import { Stack, Typography } from '@mui/material';
import React from 'react';
import { DATAGRID_ROW_HEIGHT } from 'v2/constants';

interface TextCellProps {
  variant?: 'title' | 'content' | 'subtitle';
  children: React.ReactNode;
}

export const TextCell: React.FC<TextCellProps> = ({ variant = 'content', children }) => {
  if (variant === 'title') {
    return (
      <Typography variant="body2" display="inline" noWrap>
        {children}
      </Typography>
    );
  }
  return (
    <Typography
      variant="caption"
      display="inline"
      color={variant === 'subtitle' ? 'text.secondary' : 'text.primary'}
      noWrap
    >
      {children}
    </Typography>
  );
};

interface TwoLineCellProps {
  title: string;
  content?: string | null;
  height?: number;
}

export const TwoLineCell: React.FC<TwoLineCellProps> = ({ title, content, height }) => {
  if (!content) {
    return (
      <Stack height={height ?? DATAGRID_ROW_HEIGHT} justifyContent="center" overflow="hidden" minWidth={0}>
        <TextCell variant="title">{title}</TextCell>
      </Stack>
    );
  }
  return (
    <Stack height={height ?? DATAGRID_ROW_HEIGHT} padding="6px 0" overflow="hidden" minWidth={0}>
      <TextCell variant="title">{title}</TextCell>
      <TextCell variant="subtitle">{content}</TextCell>
    </Stack>
  );
};
